import React, {
  useState
} from 'react';
import {
  Grid,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  IconButton,
  Checkbox,
  makeStyles,
  ButtonBase,
  Typography,
  Dialog,
  DialogContent,
  Button
} from '@material-ui/core';
// import Waveform from 'waveform-react';
import Delete from '@material-ui/icons/Delete';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import moment from 'moment';
import ViewArquivo from '../../../shared/component/UIElements/ViewArquivo';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  checkbox: {
    padding: '0px'
  },
  delete: {
    padding: '0px',
    margin: '8px 12px 0px 12px'
  },
  galeria: {
    marginTop: '32px'
  },
  imagem: {
    width: '100%',
    height: '132px',
    borderRadius: '4px',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
    '& img': {
      display: 'block',
      width: '100%'
    }
  },
  nome: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    lineHeight: '18px',
    color: '#434343',
    fontWeight: 500,
    display: 'block',
    width: '100%',
    padding: '16px 0px 0px 0px'
  },
  arquivo: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    lineHeight: '13px',
    color: '#ACACAC',
    fontWeight: 400,
    textTransform: 'uppercase'
  },
  actions: {
    justifyContent: 'space-between',
    padding: '0px 16px 16px 16px'
  },
  data: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    lineHeight: '13px',
    color: '#ACACAC',
    fontWeight: 400,
  },
  remover: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    color: '#808080',
    textAlign: 'center',
    maxWidth: '290px',
    margin: '15px auto'
  },
  removerholder: {
    overflowY: 'unset',
    textAlign: 'center',
    padding: '24px'
  },
  sim: {
    color: 'white',
    display: 'inline-block',
    padding: '6px 16px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
    margin: '5px 15px',
    background: '#C03A2A',
    '&:hover': {
      backgroundColor: '#C03A2A',
    },
    maxWidth: '112px'
  },
  nao: {
    color: 'white',
    display: 'inline-block',
    padding: '6px 16px',
    margin: '5px 15px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
    background: '#808080',
    '&:hover': {
      backgroundColor: '#808080',
    },
    maxWidth: '112px'
  },
  card: {
    border: '1px solid #ACACAC'
  },
  icone: {
    opacity: '0.8',
    color: '#ffffff',
    position: 'absolute',
    top: 'calc(50% - 50px)',
    left: 'calc(50% - 50px)',
    fontSize: '100px'
  },
  arquivos: {
    width: '100%',
    height: '97px',
    borderRadius: '4px',
    display: 'flex',
    alignContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    '& img': {
      display: 'block',
    }
  },
}));
const Anexo = (props) => {
  const {
    anexo,
    podeRemover = true,
    onChecked,
    onRemoveConfirma,
    selected,
  } = props;
  const classes = useStyles();
  const [remover, setRemover] = useState(false);
  const [ver, setVer] = useState(false);
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const isItemSelected = isSelected(anexo.original);
  const labelId = `anexo-checkbox-${anexo._id}`;
  const tipo = anexo.tipo.split('/')[0];
  const arquivo = anexo.caminho.split('.')[1];
  const nome = anexo.original.split('.')[0];
  let preview = <></>;

  switch (tipo) {
    case 'image':
      preview = (
        <ButtonBase className={classes.imagem} onClick={() => setVer(true)}>
          <img src={`${process.env.REACT_APP_BACKEND_IMG}${anexo.caminho}`} alt={anexo.original} />
          <PlayArrowIcon className={classes.icone} />
        </ButtonBase>
      );
      break;
    case 'audio':
      preview = (
        <ButtonBase className={classes.arquivos} onClick={() => setVer(true)}>
          <img src="/static/images/audio.png" alt={anexo.original} />
        </ButtonBase>
      );
      break;
    case 'video':
      preview = (
        <ButtonBase className={classes.arquivos} onClick={() => setVer(true)}>
          <img src="/static/images/video.png" alt={anexo.original} />
        </ButtonBase>
      );
      break;
    default:
      preview = (
        <ButtonBase className={classes.arquivos}>
          <img src="/static/images/doc.png" alt={anexo.original} />
        </ButtonBase>
      );
      break;
  }
  const abreRemove = (event, arqvs) => {
    setRemover(arqvs);
  };
  const fechaRemover = async () => {
    setRemover(false);
  };
  const removendo = async () => {
    onRemoveConfirma(remover);
    setRemover(false);
  };
  const fechaVer = async () => {
    setVer(false);
  };
  return (
    <Grid item xs={4}>
      <Card className={classes.card}>
        <CardHeader
          style={{ textAlign: 'left' }}
          title={(
            <>
              <Checkbox
                className={classes.checkbox}
                onClick={(event) => onChecked(event, anexo.original)}
                checked={isItemSelected}
                disabled={!podeRemover}
                inputProps={{ 'aria-labelledby': labelId }}
              />
            </>
          )}
          action={(
            <>
              <IconButton
                aria-label="remover"
                disabled={!podeRemover}
                className={classes.delete}
                onClick={(event) => abreRemove(event, anexo)}
              >
                <Delete />
              </IconButton>
            </>
          )}
        />
        <CardContent>
          {preview}
          <Typography
            color="textPrimary"
            align="left"
            variant="h3"
            className={classes.nome}
          >
            {nome}
          </Typography>
        </CardContent>
        <CardActions className={classes.actions}>
          <p className={classes.arquivo}>{`.${arquivo}`}</p>
          <p className={classes.data}>{moment(anexo.createdDate).format('DD/MM/YYYY HH:mm')}</p>
        </CardActions>
      </Card>
      <Dialog
        open={remover !== false}
        onClose={fechaRemover}
        fullWidth
        maxWidth="sm"
      >
        <DialogContent className={classes.removerholder}>
          <Typography className={classes.remover} color="inherit" variant="subtitle1" component="div">
            Tem certeza que deseja excluir o anexo selecionado?
          </Typography>
          <Button
            fullWidth
            marginBottom={5}
            onClick={fechaRemover}
            classes={{
              root: classes.nao
            }}
          >
            NÃO
          </Button>
          <Button
            fullWidth
            marginBottom={5}
            onClick={removendo}
            classes={{
              root: classes.sim
            }}
          >
            SIM
          </Button>
        </DialogContent>
      </Dialog>
      <ViewArquivo open={ver} anexo={anexo} onClose={fechaVer} />
    </Grid>
  );
};

export default Anexo;
